import { useMediaQuery } from '@mui/material';
import { MOBILE_MAX_WIDTH } from '@/app/stylesguides';

const useCheckIsMobileSize = () => {
  const isMobile = useMediaQuery(`(max-width:${MOBILE_MAX_WIDTH}px)`);
  return isMobile;
};

export default useCheckIsMobileSize;
